(() => {
  const controllers = new WeakMap();
  const selector = '[data-ms-resources]';
  function initialize(root = document) {
    const sections = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) sections.push(root);
    for (const section of sections) {
      if (controllers.has(section)) continue;
      const documents = section.querySelector('[data-documents]');
      const search = section.querySelector('input[type="search"]');
      const sort = section.querySelector('select');
      const empty = section.querySelector('[data-document-empty]');
      if (!documents || !search || !sort || !empty) continue;
      const controller = new AbortController();
      controllers.set(section, controller);
      let category = 'all';
      function filter() {
        const cards = [...documents.children].sort((a, b) => a.dataset.name.localeCompare(b.dataset.name) * (sort.value === 'reverse' ? -1 : 1));
        for (const card of cards) {
          card.hidden = !(category === 'all' || card.dataset.documentCategory === category) || !card.dataset.name.toLowerCase().includes(search.value.toLowerCase());
          documents.append(card);
        }
        empty.hidden = cards.some(card => !card.hidden);
      }
      function revealLinkedDocument() {
        const target = document.getElementById(location.hash.slice(1));
        if (!target || target.parentElement !== documents) return;
        category = 'all';
        search.value = target.dataset.documentModel || '';
        section.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === 'all')));
        filter();
        requestAnimationFrame(() => { if (target.isConnected) target.scrollIntoView({ block: 'start' }); });
      }
      search.addEventListener('input', filter, { signal: controller.signal });
      sort.addEventListener('change', filter, { signal: controller.signal });
      section.addEventListener('click', event => {
        const button = event.target.closest('[data-category], [data-view]');
        if (!button || !section.contains(button)) return;
        if (button.dataset.category) {
          category = button.dataset.category;
          section.querySelectorAll('[data-category]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          filter();
        } else {
          documents.classList.toggle('is-list', button.dataset.view === 'list');
          section.querySelectorAll('[data-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }
      }, { signal: controller.signal });
      filter();
      revealLinkedDocument();
      window.addEventListener('hashchange', revealLinkedDocument, { signal: controller.signal });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const sections = [...event.target.querySelectorAll(selector)];
    if (event.target.matches?.(selector)) sections.push(event.target);
    sections.forEach(section => { controllers.get(section)?.abort(); controllers.delete(section); });
  });
})();
